import { Button, Col, Input, Modal, Row, Typography } from "antd";
import "./userChangePasswordModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { userChangePasswordService } from "../../services/user.service";
import { toast } from "react-toastify";
import PasswordStrengthBar from "react-password-strength-bar";

interface Props {
  show: boolean;
  onClose: () => void;
}

export const UserChangePasswordModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [retryNewPassword, setRetryNewPassword] = useState("");

  const [isPasswordStrong, setIsPasswordStrong] = useState(false);
  

  useEffect(() => {
    setShow(props.show);
    if (props.show) {
      setNewPassword("");
      setCurrentPassword("");
      setRetryNewPassword("");
    }
  }, [props.show]);

  const submit = async () => {
    try {
      
      

      if(!isPasswordStrong){
        toast.error("رمز عبور ضعیف است")
        return
      }
      
      setLoading(true)
            
      const res = await userChangePasswordService({
        current_password: currentPassword,
        new_password: newPassword,
        retry_new_password: retryNewPassword,
      });

      setLoading(false);
      toast.success("رمز عبور جدید با موفقیت ثبت شد ");
      setShow(false);
      props.onClose();
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="UserChangePasswordModal">
      <Modal
        destroyOnClose={true}
        title={"تغییر رمز عبور"}
        onCancel={() => {
          setShow(false);
          props.onClose();
        }}
        open={show}
        footer={null}
        width={600}
      >
        <div className="UserChangePasswordModalContent">
          <Row justify={"space-between"} align={"middle"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">
                رمز عبور فعلی:{" "}
              </Typography.Text>
              <Input.Password
                className="input"
                value={currentPassword}
                onChange={(e) => {
                  setCurrentPassword(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"} align={"top"}>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                رمز عبور جدید:{" "}
              </Typography.Text>
              <Input.Password
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
                className="input"
              />
              <PasswordStrengthBar
                scoreWords={["ضعیف", "ضعیف", "متوسط", "خوب", "قوی"]}
                shortScoreWord={"خیلی ضعیف"}
                password={newPassword}
                onChangeScore={(e)=>{
                  if(e >= 3){
                    setIsPasswordStrong(true)
                  }else{
                    setIsPasswordStrong(false)
                  }
                  
                }}
              />
            </Col>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                تکرار رمز عبور جدید:{" "}
              </Typography.Text>
              <Input.Password
                value={retryNewPassword}
                onChange={(e) => {
                  setRetryNewPassword(e.target.value);
                }}
                className="input"
              />
            </Col>
          </Row>
          <Row justify={"center"}>
            <Col xs={24}>
              <Button
                onClick={submit}
                loading={loading}
                className="btn"
                type="primary"
                block
              >
                تایید
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
